import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpService} from "../http.service";
import {environment} from "@shared-environments/environment";

@Injectable()
export class WhiteLabelPageService {


    constructor(private networkHelper: HttpService) { }

    private getByIdUrl = '/white-label-page/:id';
    private deleteUrl = '/white-label-page/:id';
    private updateUrl = '/white-label-page/:id';
    private updateBySlugUrl = '/white-label-page/slug/:slug';
    private getByIdSlug = '/white-label-page/slug/:slug';
    private createUrl = '/white-label-page/add';
    private listUrl = '/white-label-page/list'


    getById(id: string){
        return this.networkHelper.get<any>(environment.apiURL + this.getByIdUrl.replace(':id', id));
    }

    getBySlug(slug: string){
        return this.networkHelper.getWithSSR<any>(environment.apiURL + this.getByIdSlug.replace(':slug', slug));
    }

    list(pagination:any, filter:any){
        return this.networkHelper.get<any>(environment.apiURL + this.listUrl,{...pagination, ...filter});
    }
    update(id: string, data: any){
        return this.networkHelper.put<any>(environment.apiURL + this.updateUrl.replace(':id', id), data);
    }

    updateBySlug(slug: string, data: any){
        return this.networkHelper.put<any>(environment.apiURL + this.updateBySlugUrl.replace(':slug', slug), data);

    }

    create(data: any){
        return this.networkHelper.post<any>(environment.apiURL + this.createUrl, data);
    }

    delete(id: string){
        return this.networkHelper.del<any>(environment.apiURL + this.deleteUrl.replace(':id', id));

    }

}
